// Format patterns for identifiers we accept but do not generate ourselves
export const objectIdPattern = /^[0-9a-f]{24}$/i; // MongoDB ObjectId pattern
export const roomCodePattern = /^\d{6}$/; // Room code pattern (6-digit number)
export const serverIdPattern = /^[a-zA-Z0-9-]+\/[a-zA-Z0-9-]+$/; // Server ID pattern (format: serviceName/instanceId)
export const sessionCookiePattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i; // Session cookie pattern
//# sourceMappingURL=idPatterns.js.map